export function parseQualityAlertDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const partIdRaw = params.get('partId');
  const alertIdRaw = params.get('alertId');
  const partId = partIdRaw ? Number(partIdRaw) : null;
  const alertId = alertIdRaw ? Number(alertIdRaw) : null;

  if (!(Number.isFinite(partId) && partId > 0)) {
    return null;
  }

  return {
    partId,
    alertId: Number.isFinite(alertId) && alertId > 0 ? alertId : null,
  };
}
